<template>
  <div>
    <b-table
      :items="dataTable.data"
      :fields="fields"
      :busy="loading"
      class="col-12 mt-5 table-views"
      show-empty
    >
      <template #empty>
        <div class="text-center my-2">
          <h2>Sin datos para mostrar</h2>
        </div>
      </template>
      <template #table-busy>
        <div class="text-center my-2 mb-3">
          <overlay-button></overlay-button>
        </div>
      </template>
      <template #cell(activity)="data">
        {{ data?.item?.activity?.name }}
      </template>
      <template #cell(position)="data">
        {{ data?.item?.position?.name }}
      </template>
      <template #cell(noMitigation)="data">
        <div
          class="risk-activity"
          :style="{
            backgroundColor: classificationRisk(
              data?.item?.without_mitigation_score
            )?.background,
            color: classificationRisk(data?.item?.without_mitigation_score)
              ?.color,
          }"
        >
          <img
            class="mr-2"
            :src="
              classificationRisk(data?.item?.without_mitigation_score)?.icon
            "
            alt=""
          />
          <span>{{
            classificationRisk(data?.item?.without_mitigation_score)?.name
          }}</span>
        </div>
      </template>
      <template #cell(mitigation)="data">
        <div
          class="risk-activity"
          :style="{
            backgroundColor: classificationRisk(data?.item?.mitigation_score)
              ?.background,
            color: classificationRisk(data?.item?.mitigation_score)?.color,
          }"
        >
          <img
            class="mr-2"
            :src="classificationRisk(data?.item?.mitigation_score)?.icon"
            alt=""
          />
          <span>{{
            classificationRisk(data?.item?.mitigation_score)?.name
          }}</span>
        </div>
      </template>
    </b-table>

    <div class="col-12 cont-pagination my-5 d-flex justify-content-center">
      <Pagination
        v-if="!loading"
        :data="dataTable"
        :limit="15"
        @pagination-change-page="loadRowsPag"
      ></Pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "laravel-vue-pagination";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";

export default {
  components: {
    Pagination,
    OverlayButton,
  },
  props: {
    dataTable: {
      type: Object,
      default: () => {
        return {};
      },
    },
    loading: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    risks: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fields: [
        {
          key: "activity",
          label: "Actividad",
        },
        {
          key: "position",
          label: "Cargo",
        },
        {
          key: "noMitigation",
          label: "Clasificación sin mitigación",
        },
        {
          key: "mitigation",
          label: "Clasificación con mitigación",
        },
        {
          key: "created_at",
          label: "Fecha de registro",
        },
      ],
    };
  },
  methods: {
    loadRowsPag(page) {
      const me = this;
      me.$emit("loadRowsPag", page);
    },
    classificationRisk(score) {
      const me = this;
      let risk = me.risks.find((risk) => {
        // Si el score es un rango [min, max], verificar si el número está en ese rango
        if (risk.score.length === 2) {
          return score >= risk.score[0] && score <= risk.score[1];
        }
        // Si el score es un valor único
        return score <= risk.score[0];
      });
      return risk;
    },
  },
};
</script>

<style lang="css">
.button-table-employee {
  border: none;
  background-color: white;
}

.btn_risk_potential {
  background-color: white;
  border: 1px solid #5d5fef;
  border-radius: 8px;
  padding: 10px;
  font-size: 16px;
  color: #5d5fef;
}

.custom-tooltip-ht .tooltip-inner {
  max-width: 200px !important;
  background-color: #263238 !important;
  font-size: 14px !important;
}
</style>
